import React from 'react';
import PropTypes from 'prop-types';

export default function CalendarIcon(props) {
  return (
    <svg width="36" height="36" viewBox="0 0 36 36" className={props.className}>
      <path fill="#a4b0bf" fillRule="nonzero" d="M9.854 8h16.292C27.17 8 28 8.83 28 9.854V26.54c0 1.024-.83 1.854-1.854 1.854H9.854A1.853 1.853 0 0 1 8 26.54V9.854C8 8.83 8.83 8 9.854 8zm16.292 5.562H9.854V26.54h16.292V13.562zm-11.709 5.585h-1.874a.564.564 0 0 1-.563-.563v-1.875c0-.31.253-.562.563-.562h1.874c.31 0 .563.253.563.562v1.875c0 .31-.253.563-.563.563zm5.063-.563c0 .31-.253.563-.563.563h-1.875a.564.564 0 0 1-.562-.563v-1.875c0-.31.253-.562.563-.562h1.875c.309 0 .562.253.562.562v1.875zm4.5 0c0 .31-.253.563-.563.563h-1.875a.564.564 0 0 1-.562-.563v-1.875c0-.31.253-.562.563-.562h1.875c.309 0 .562.253.562.562v1.875zm-4.5 4.5c0 .31-.253.563-.563.563h-1.875a.564.564 0 0 1-.562-.563v-1.875c0-.31.253-.562.563-.562h1.875c.309 0 .562.253.562.562v1.875zm-4.5 0c0 .31-.253.563-.563.563h-1.874a.564.564 0 0 1-.563-.563v-1.875c0-.31.253-.562.563-.562h1.874c.31 0 .563.253.563.562v1.875zm9 0c0 .31-.253.563-.563.563h-1.875a.564.564 0 0 1-.562-.563v-1.875c0-.31.253-.562.563-.562h1.875c.309 0 .562.253.562.562v1.875z" />
    </svg>

  );
}

CalendarIcon.propTypes = {
  className: PropTypes.string,
};

CalendarIcon.defaultProps = {
  className: null,
};



// WEBPACK FOOTER //
// ./src/components/controls/icons/CalendarIcon.jsx